module.exports = __webpack_public_path__ + "static/img/twin-highway-3.3282f66c.png";